import React from 'react';
import { useAppFeatures, type AppFeatures } from '../../contexts/AppFeaturesContext';

type FeatureName = keyof AppFeatures;

interface Props {
  name: FeatureName;
  fallback?: React.ReactNode;
}

const RequireFeature: React.FC<React.PropsWithChildren<Props>> = ({ name, fallback = null, children }) => {
  const features = useAppFeatures();
  if (!features[name]) return <>{fallback}</>;
  return <>{children}</>;
};

export default RequireFeature;
